<div class="board">
  <div class="boardContent">
    <table *ngFor="let rows of numbers" class="boardTable">
      <td *ngFor="let columns of rows" class="boardColumn">
        <tr class="numberBoard">
          <button
            mat-stroked-button
            class="btnBoard"
            type="button"
            (click)="getValue(columns)"
          >
            {{ columns }}
          </button>
        </tr>
      </td>
    </table>
  </div>
</div>
